import React from 'react';
import Box from "@mui/material/Box";
import { TabContext, TabList } from '@mui/lab';
import makeStyles from "@mui/styles/makeStyles";
import { Tab, Typography } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  root: {
    background: "white",
    display: "flex",
    width: '100%',
    justifyContent: "stretch", 
    border: '2px solid',
    borderColor: theme.palette.neutral.main,
    borderRadius: theme.spacing(1),
    overflow: 'hidden'
  },
  tab: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
    cursor: "pointer",
    transition: "400ms ease-in-out",
    padding: theme.spacing(2, 4),
    borderColor: theme.palette.neutral.main,
    flexGrow: 1,
    flexBasis: 0, 
  },
  activeTab: {
    backgroundColor: theme.palette.secondary.main
  },
  simpleTab: {
    ...theme.typography['h6-semiBold'],
    textTransform: 'capitalize',
    display: 'flex',
    flexGrow: 1
  },
  tabList: {
    width: '100%', 
    '& .MuiTabs-flexContainer': {
      width: '100%', 
      display: 'flex',
    },
    '& .MuiTab-root': {
      flexGrow: 1, 
    }
  }
}));

function Tabs({
  value,
  options = [],
  onChange = () => { },
  ...props
}) {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {
        options.map((option, index) => {
          return (
            <Box
              key={index}
              className={`${classes.tab} ${option._id === value ? classes.activeTab : ''}`}
              onClick={() => onChange(option._id)}
              style={{
                borderRight: index < options.length - 1 ? '2px solid' : 'none'
              }}
              {...props}
            >
              {
                option.icon
                  ? <img src={option.icon} alt={option.label} />
                  : null
              }
              <Typography variant="h6-medium" color={'neutral.clr-800'}>
                {option?.label || index}
              </Typography>
            </Box>
          )
        })
      }
    </Box>
  );
}

export default Tabs;

export const SimpleTabs = ({
  options = [],
  value = null,
  onChange = () => { }
}) => {
  const classes = useStyles();

  const handleChange = (event, newValue) => {
    onChange(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
          <TabList 
            onChange={handleChange} 
            aria-label="lab API tabs example"
            className={classes.tabList}
            variant="fullWidth" 
          >
            {
              options.map((option, index) => {
                return (
                  <Tab
                    label={option.label}
                    value={option.value}
                    key={index}
                    className={classes.simpleTab}
                  />
                )
              })
            }
          </TabList>
        </Box>
      </TabContext>
    </Box>
  )
}